import React, { useState } from 'react';
import logo from '../img/logo_escuela.png';
/* import facebook from '../img/facebookcircle.png';
import instagram from '../img/instagramcircle.png';
import twitter from '../img/twittercircle.png';
import youtubeicono from '../img/youtubeicono.png'; */

import facebook from '../img/facebook-R.png';
import instagram from '../img/instagran-R.png';
import twitter from '../img/x-R.png';
import youtubeicono from '../img/youtube-R.png';




import '../App.css'; // Asegúrate de importar tus estilos CSS

const Header = () => {
  const [iconHovered, setIconHovered] = useState(null);

  const handleIconClick = (icon) => {
    if (iconHovered === icon) {
      setIconHovered(null);
    } else {
      setIconHovered(icon);
    }
  };

  return (
    <div className="header" style={headerStyle}>
      <div className="logo-container">
        <div className="logo">
          {/* Aquí puedes colocar el logotipo si es necesario */}
        </div>
      </div>

      <div className="text-container">
        <div className="logo-text" style={textStyle}>
          {/* Texto o contenido adicional */}
        </div>
      </div>

      <div className="social-icons" style={socialIconsStyle}>
        <a
          href="https://www.instagram.com/nuevazelandiaescuela/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleIconClick('instagram')}
        >
          <img
            src={instagram}
            alt="Logo de Instagram"
            className={`icon ${iconHovered === 'instagram' ? 'hovered' : ''}`}
            style={iconStyle}
          />
        </a>
        <a
          href="https://twitter.com/zelandia_nueva?lang=bg/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleIconClick('twitter')}
        >
          <img
            src={twitter}
            alt="Logo de Twitter"
            className={`icon ${iconHovered === 'twitter' ? 'hovered' : ''}`}
            style={iconStyle}
          />
        </a>
        <a
          href="https://www.facebook.com/EscuelaNuevaZelancia"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleIconClick('facebook')}
        >
          <img
            src={facebook}
            alt="Logo de Facebook"
            className={`icon ${iconHovered === 'facebook' ? 'hovered' : ''}`}
            style={iconStyle}
          />
        </a>
        <a
          href="https://www.youtube.com/channel/UCv9kvVQXl1zXASkSQfra55w"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleIconClick('youtube')}
        >
          <img
            src={youtubeicono}
            alt="Logo de Youtube"
            className={`icon ${iconHovered === 'youtube' ? 'hovered' : ''}`}
            style={iconStyle}
          />
        </a>
      </div>
    </div>
  );
};

const headerStyle = {
  position: 'relative', // Para que los íconos puedan posicionarse con 'absolute'
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px',
  color: 'white',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

const socialIconsStyle = {
  position: 'absolute',  // Posiciona los íconos de forma absoluta
  top: '4px',           // Distancia desde la parte superior
  right: '10px',         // Alinea a la derecha
  display: 'flex',       // Íconos en una fila (horizontal)
  gap: '10px',           // Espacio entre los íconos
};

const iconStyle = {
  width: '30px',  // Tamaño reducido de los íconos
  height: '30px', // Ajusta el tamaño de acuerdo a tu necesidad
};

const textStyle = {
  color: 'black',
  fontSize: '30px',
  marginLeft: '20px', // Ajusta la distancia a la derecha aquí
};

export default Header;
